"use strict";
var TimerObservable_1 = require("./TimerObservable");
exports.timer = TimerObservable_1.TimerObservable.create;
//# sourceMappingURL=timer.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/observable/timer.js
 ** module id = 244
 ** module chunks = 1
 **/